import { getBaseURL } from 'services/settings';

/** Base of every API request: services build URLs as `${getBaseSalesURL()}${ApiEndpoints.X}`, as reactjs-frontend-s2c does. */
export const getBaseSalesURL = (): string => getBaseURL();
